export const REGISTERED_LANGUAGES = ['en-US', 'pt-BR', 'es'] as const;

export const DEFAULT_LANGUAGE = 'pt-BR';

export type Language = (typeof REGISTERED_LANGUAGES)[number];
